import { render, staticRenderFns } from "./PracticeSettingForm.vue?vue&type=template&id=783584a8&scoped=true&"
import script from "./PracticeSettingForm.vue?vue&type=script&lang=js&"
export * from "./PracticeSettingForm.vue?vue&type=script&lang=js&"
import style0 from "./PracticeSettingForm.vue?vue&type=style&index=0&id=783584a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783584a8",
  null
  
)

export default component.exports